import { call, put, takeEvery, all } from 'redux-saga/effects'
import historyTypes from './historyTypes'
import * as historyActions from './historyActions'
import HistoryOffers from '../../services/OffersService/HistoryOffers'

export function * getHistoryOffers ({ payload }) {
  try {
    const { offset } = payload
    if (offset === 0) {
      yield put(historyActions.clearHistoryOffers())
    }
    const { data, results } = yield call(HistoryOffers.history, payload)
    yield put(historyActions.getHistoryOffersSuccess({ data, results }))
  } catch ({ message }) {
    yield put(historyActions.getHistoryOffersFailure(message))
  }
}

export function * onGetOffers () {
  yield takeEvery(historyTypes.GET_HISTORY, getHistoryOffers)
}

export function * historyOffersSaga () {
  yield all([
    call(onGetOffers)
  ])
}
